<template>
  <el-dialog class="dialog-edit-role" :title="title" :visible.sync="visible" width="1000px">
    <ConfigForms ref="form" labelWidth="110px" :formItems="formItems" :data="formData" inline />
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="sure" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ConfigForms from '@/components/config-forms';
// import { roleTagTypes } from '../../config';

const formItems = [
  { type: 'image', label: '图标', required: true, key: 'icon' }, // 上传图片
  { type: 'text', label: '名称', required: true, key: 'name' },
  { type: 'textarea', label: '详细描述', required: true, key: 'description' },
  // { type: 'select', label: '类型', required: true, key: 'type', options: roleTagTypes },
  { type: 'switch', label: '状态', required: true, key: 'status' },
  { type: 'switch', label: '是否热门', required: true, key: 'isHot' },
  { type: 'number', label: '排序', required: true, key: 'sort' },
  { type: 'number', label: '权重', required: true, key: 'weight' },
]
export default {
  name: 'EditRole',
  emit: ['close'],
  components: { ConfigForms },
  data() {
    return {
      visible: false,
      formItems,
      formData: null,
    };
  },
  watch: {
  },
  computed: {
    isEdit() {
      return !!this.formData
    },
    title() {
      return this.isEdit ? '编辑角色标签' : '新增角色标签'
    }
  },
  created() {

  },
  methods: {
    close() {
      this.visible = false
    },
    open(row) {
      this.formData = null
      if (row) {
        // TODO：参数待完善
        this.formData = { ...row }
      }
      this.visible = true
    },
    async sure() {
      try {
        const form = await this.$refs.form.validate();
        const data = { ...form }
        this.$emit('sure', { isEdit: this.isEdit, data })
      } catch (error) {
        console.error('sure error:', error);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.dialog-edit-role {
  /deep/ .el-date-editor.el-input {
    width: 200px;

  }
}
</style>
